module.exports = __webpack_public_path__ + "dcc9e25719a0efa44aa44c1edcbc7bbd.svg";